export enum CurrencyType {
  Eur = "EUR",
  Usd = "USD",
}

export const CurrencySymbol: Record<CurrencyType, string> = {
  [CurrencyType.Eur]: "€",
  [CurrencyType.Usd]: "$",
} as const;
